var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2 36.1c.9-.1 1.8-.1 2.8-.1 7.4 0 14 1.7 18.5 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6 9.6C64.2 12.3 57.5 14 50 14c-7.4 0-14-1.7-18.5-4.3M26 25h48M50 1v48"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3 48.7c1.2.2 2.5.3 3.7.3 13.3 0 24-10.7 24-24S63.3 1 50 1 26 11.7 26 25c0 2 .3 3.9.7 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8 48.2c1 .6 2.1.8 3.2.8 6.6 0 12-10.7 12-24S56.6 1 50 1 38 11.7 38 25c0 1.4.1 2.7.2 4v.2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M12.4 17.9c2.9-2.9 5.4-4.8.3-11.2S4.1 5.2 1.3 8.1c-3.3 3.3-.2 15.4 11.8 27.5s24.3 15.2 27.5 11.9c2.8-2.8 7.8-6.3 1.4-11.5s-8.3-2.6-11.2.3c-2 2-7.2-2.2-11.7-6.7s-8.7-9.7-6.7-11.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalPhoneNumber);
export default __webpack_public_path__ + "static/media/internationalPhoneNumber.0f72d6bfdffe1f2902219ad5cd91df6e.svg";
export { ForwardRef as ReactComponent };